import styled from 'styled-components'

export const Container = styled.div`
  position: absolute;
  background-color: var(--color-white);
  padding: 40px 60px;
  outline: none;
  width: 500px;
  border-radius: 10px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-y: auto;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`

export const Title = styled.p`
  color: var(--color-oxford-blue);
  text-align: center;
  margin-bottom: 8px;
  word-break: break-word;

  font-weight: bold;
  font-size: 24px;
`

export const SubTitle = styled.p`
  font-size: 16px;
  color: var(--color-text-secondary);
`

export const IconWrap = styled.div`
  position: absolute;
  top: 24px;
  right: 24px;
  cursor: pointer;
`

export const ButtonsWrap = styled.div`
  margin-top: 0.5rem;
  display: flex;
  gap: 8px;
`